/** In-call face rules (SPEC_V2 §7). Pure so it can be unit tested. */
export const PAUSE_AFTER_MS = 5_000;
export const RESUME_AFTER_MS = 1_000;
export const END_AFTER_MS = 30_000;
/** Before matching: a face must be seen for ≥ 1 s. */
export const GATE_PRESENT_MS = 1_000;

export interface FaceSample {
  ready: boolean;
  faceVisible: boolean;
  absentForMs: number;
  presentForMs: number;
}

export interface GuardDecision {
  paused: boolean;
  end: boolean;
}

export function nextGuard(paused: boolean, s: FaceSample): GuardDecision {
  if (!s.ready) return { paused, end: false };
  let p = paused;
  if (!p && s.absentForMs >= PAUSE_AFTER_MS) p = true;
  else if (p && s.faceVisible && s.presentForMs >= RESUME_AFTER_MS) p = false;
  return { paused: p, end: s.absentForMs >= END_AFTER_MS };
}

export function gatePassed(s: FaceSample): boolean {
  return s.ready && s.faceVisible && s.presentForMs >= GATE_PRESENT_MS;
}

/** SPEC_V4 §7 corrected copy. */
export const FACE_PRIVACY =
  'Your own face check runs on your device and sends nothing. Separately, people you call are protected by a safety check on their device (see guidelines).';
